import type { AdminReadiness } from '@fonus/shared';

const LANG: Record<string, string> = { uz: 'uz', ru: 'ru', en: 'en' };

/** Why "Create a story" is disabled, in one line — or null when it may run. */
export function createBlocker(
  r: AdminReadiness | undefined,
  /** Languages that will be voiced (uploaded narration needs no voice); default: all. */
  voicesFor?: string[],
): string | null {
  if (!r) return 'Проверяем готовность…';
  if (r.paused) return 'Генерация остановлена (пауза)';
  const claude = r.steps.find((s) => s.id === 'claude');
  const el = r.steps.find((s) => s.id === 'elevenlabs');
  const voices = r.steps.find((s) => s.id === 'voices');
  if (claude?.status !== 'done') return 'Сначала подключите ключ Claude';
  if (el?.status !== 'done') return 'Сначала подключите ключ ElevenLabs';
  if (voices?.status !== 'done') {
    const missing = ((voices?.detail.missing as string[] | undefined) ?? []).filter(
      (l) => !voicesFor || voicesFor.includes(l),
    );
    if (missing.length > 0 || !voicesFor)
      return `Сначала выберите голос для ${missing.map((l) => LANG[l] ?? l).join(', ')}`;
  }
  if (r.busy && r.busy.type !== 'VOICE_SAMPLE') return 'Уже идёт генерация или озвучка';
  return null;
}
